module.exports = __webpack_public_path__ + "static/media/M92ws.3a30490a.pdf";